import {gql} from "@apollo/client";
import {Inquiry} from "@App/types";

export interface CreateInquiryQuery {
    createInquiry: Inquiry
}

export const CREATE_INQUIRY = gql`
    mutation CreateInquiry(
        $organization: ID!,
        $garage: ID!,
        $state: InquiryState,
        $services: [ID]!,
        $service: ID,
        $salutation: Int,
        $firstName: String!,
        $lastName: String!,
        $email: String!,
        $phone: String!,
        $street: String,
        $city: String,
        $postcode: String,
        $addition: String,
        $numberPlate: String,
        $mileage: Int,
        $message: String,
        $tos: Boolean!,
        $slot: ID,
        $marketing: Boolean,
        $adacMember: Boolean,
        $startDate: DateTimeTz!,
        $endDate: DateTimeTz!,
        $calendarId: ID!,
        $premiumServices: [Int],
        $brand: ID,
        $generation: ID,
        $motorization: ID,
        $body: ID,
        $gearbox: ID,
        $registrationDate: Date,
        $subRepairs: [String]
        $equipments: [String]
        $additionalPremiumServiceInformation: [AdditionalPremiumServiceInformation]) {
        createInquiry(
            input: {
                organization: $organization,
                garage: $garage,
                state: $state,
                services: $services,
                service: $service,
                salutation: $salutation,
                firstName: $firstName,
                lastName: $lastName,
                email: $email,
                phone: $phone,
                street: $street,
                city:  $city,
                postcode: $postcode,
                addition: $addition,
                numberPlate: $numberPlate,
                mileage: $mileage,
                message: $message,
                tos: $tos,
                slot: $slot,
                marketing: $marketing,
                adacMember: $adacMember,
                from: $startDate,
                to: $endDate,
                calendar: $calendarId,
                premiumServices: $premiumServices,
                brand: $brand,
                generation: $generation,
                motorization: $motorization,
                body: $body,
                gearbox: $gearbox,
                registrationDate: $registrationDate,
                sub_repairs: $subRepairs,
                equipments: $equipments,
                additionalPremiumServiceInformation: $additionalPremiumServiceInformation
            }
        ) {
            id
            uuid
        }
    }
`
